import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Candidate } from 'app/shared/models/candidate.model';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {


  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  searchByName=''
  searchVal=null
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Address", prop: "Address" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;

  candidate_id:any
  isActivated:boolean
  @ViewChild('name') inputName;
  user_role:any
  opening_status_cat_id ='64c246476ae6f958da59fae3'
    status_list =[]
    selected_status=null
    isdropDownFilter:boolean =false
    opening_list=[]
    appliedSort_list=[
      {name:'applied_for'},
      {name:'sort_listed'},
      {name:'all'}
    ]
    selected_appliedSort = null
    selected_opening  = null
    guideline_data:any
    client_tagging_cat_id='67dd1263eb8b300f79d31a32'   
    client_tags_list=[]
    selected_tag_id = null
    candidate_model = new Candidate();
    isEditor : boolean =false
    row_data:any
  constructor(public apiService:ApiService,
             private spinner: NgxSpinnerService,  
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session: SessionStorageService,
              private router:Router) {
                this.getStatusList()
              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Candidates')
              this.guideline_data = key_data[0]?._id
              
               }

  ngOnInit(): void {
    this.selected_appliedSort = 'all'
   
    this.getAllOpening()
    this.getTaggingTags()
  }
  getStatusList(){
    this.apiService.getTagByTagCatgoryId(this.opening_status_cat_id).subscribe((res:any)=>{
      this.status_list=res.data
      let data = { displayname:'All',_id:'all'}
      this.status_list.push(data)
      let status_id = this.status_list.filter((item:any)=> item?.name ==='open')
      this.selected_status = status_id[0]?._id
    })
  }
  getTaggingTags(){
    this.apiService.getTagByTagCatgoryId(this.client_tagging_cat_id).subscribe((res:any)=>{
      this.client_tags_list = res.data
    })
  }
  getAllOpening(){
    this.apiService.getOpeningList(1, 100).subscribe((res: any) => {
        this.opening_list=res?.data?.items
        let data = { title:'All',_id:'all'}
        this.opening_list.push(data)
        this.selected_opening = 'all'
        this.getCandidateByQuery(this.selected_status,this.selected_opening)
        this.getJobOpeningIdByStatus(this.selected_status)
      })
    }
  getStatusId(event){
    this.selected_status
    if(!this.selected_status){
      this.selected_status =''
    }
    this.selected_opening = 'all'
    this.getJobOpeningIdByStatus(this.selected_status)
    if(this.selected_status && this.selected_opening && this.selected_appliedSort){
      this.getCandidateByQuery(this.selected_status,this.selected_opening)
    }
  }
  getJobOpeningIdByStatus(id){
    this.apiService.getOpeningListByStatus(id).subscribe((res:any)=>{
      this.opening_list = res?.data?.items
      let data = { title:'All',_id:'all'}
      this.opening_list.push(data)
    })
  }
  getOpeningId(event){
    this.selected_opening
    if(!this.selected_opening){
      this.selected_opening =''
    }
    if(this.selected_status && this.selected_opening && this.selected_appliedSort){
      this.getCandidateByQuery(this.selected_status,this.selected_opening)
    }
  }
  getAppliedSortId(event){
    this.selected_appliedSort = event.name
    if(!this.selected_appliedSort){
      this.selected_appliedSort =''
    }
    if(this.selected_status && this.selected_opening && this.selected_appliedSort){
      this.getCandidateByQuery(this.selected_status,this.selected_opening)
    }
  }

  getCandidateByQuery(status,opening_id){
    this.isdropDownFilter = true
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getCandidateBySatatusAndJobOpening(this.page.pageNumber+1,this.limitRef,opening_id==='all'?'':opening_id,status === 'all' ? '' : status).subscribe((res:any)=>{
      this.spinner.hide();
        this.spinner.hide();
        this.rows =res?.data?.items
        this.page.totalPages=res?.data?.totalCount
  
    })

  }

  getAllCandidates(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllCandidates(this.page.pageNumber +1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    })
  }
  pageChangeData(page:any) {
    this.apiService.getCandidateBySatatusAndJobOpening(page.offset +1,this.limitRef,this.selected_opening ==='all'?'':this.selected_opening,this.selected_status ==='all'?'':this.selected_status).subscribe((res:any)=>{
      this.spinner.hide();
        this.spinner.hide();
        this.rows =res?.data?.items
        this.page.totalPages=res?.data?.totalCount
  
    })
  }
  
 
  resetFilter(){
    this.inputName.nativeElement.value=null
    this.selected_status =null
    this.isdropDownFilter =false
    this.getAllCandidates()
  }
  filterCandidate(data){
    this.apiService.getFilterCandidates(data).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.rows=res.data
      }
      else{
        this.getAllCandidates()
      }
    })
  }
  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * filterUpdate
   *
   * @param event
   */
   filterUpdate(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.tempData.filter(function (d) {
      return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    this.filterRows=temp
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  /**
   * updateLimit
   *
   * @param limit
   */
  updateLimit(limit) {
    this.limitRef = limit.target.value;
    this.apiService.getAllCandidates(1,this.limitRef).subscribe((res:any)=>{
    })
  }
 
  deleteCandidates(){
    if(this.candidate_id){
      this.apiService.deleteCandidates(this.candidate_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getAllCandidates()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }

   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.candidate_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteCandidates()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  editCandidate(data){
    this.router.navigate(['/candidates-management/edit',data._id])
    
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  updateTags(data:any,tagId:any){
    this.candidate_model = data
    this.candidate_model.tagging = tagId
    // let body={
    //   tagging : tagId
    // }
    this.apiService.updateCandidates(this.candidate_model._id,this.candidate_model).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('tag updated successfully')
        this.getAllCandidates()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  submit(){
  
    this.apiService.updateCandidates(this.candidate_model._id,this.candidate_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.isEditor =false
      }
      else this.toastr.error(res?.error)
    })
  }
  openModal(content,data){
    this.candidate_model = data
    const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.candidate_model = null;
      },
      (reason) => {
        this.candidate_model = null;
      }
    );
  }
  inlineAddupdateBody(data ,prop) {
    if (prop == 'notes') {
        this.candidate_model.notes =data
      }
    if(prop == 'admin_notes') {
      this.candidate_model.admin_notes =data

    }

  }
}

